export const PER_PAGE = 10;
export const BATCH_SIZE = 100;

export const getPaginationTotal = (data: unknown[] | undefined, hasMoreData: boolean) => {
  const len = data?.length || 0;
  const batchSize = BATCH_SIZE;
  const isTotalUnknown = len > 0 && len % batchSize === 0;
  return isTotalUnknown && hasMoreData ? len + 1 : len;
};

export const isTableLoading = (
  data: unknown[] | undefined,
  currentPage: number,
  hasMoreData: boolean,
) => {
  if (!data) {
    return true;
  }
  return (
    data &&
    data.length > 0 &&
    data.length % BATCH_SIZE === 0 &&
    data.length < currentPage * PER_PAGE &&
    hasMoreData
  );
};
